module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "viewcharity"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "blog-section white-bg clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 col-md-push-7"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_c('h3', {
    staticClass: "heading"
  }, [_c('br'), _vm._v(" "), _c('i', {
    staticClass: "nav-icon giving-icon"
  }), _vm._v(" "), _c('br'), _c('span', [_vm._v(_vm._s(_vm.selectedCharity.name))])]), _vm._v(" "), _c('p', [_vm._v("\n                            " + _vm._s(_vm.selectedCharity.description) + " "), _c('br')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 col-md-pull-5"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "slider responsive-slick-slider"
  }, [_c('div', {
    staticClass: "slide-player"
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.selectedCharity.img_url
    }
  })])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-78b910b7", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78b910b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/Charities.vue